import { render } from "./Apps.vue?vue&type=template&id=51628907&scoped=true"
import script from "./Apps.vue?vue&type=script&lang=js"
export * from "./Apps.vue?vue&type=script&lang=js"

import "./Apps.vue?vue&type=style&index=0&id=51628907&lang=css&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51628907"]])

export default __exports__